import { memo, type FC, type MouseEvent, type ReactNode } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { Button } from '../../../Controls/Button/index.tsx';
import Icons from '../../../Elements/Icons/index.ts';
import { ListItem } from '../styled.ts';
import type { Option } from '../types.ts';

interface CreatableListItemProps {
  item: Option;
  formatOptionLabel?: (option: Option) => ReactNode;
  disabled: boolean;
  isEditMode: boolean;
  dataTestId?: string;
  onRemove: (value: string) => void;
}

export const CreatableListItem: FC<CreatableListItemProps> = memo(function CreatableListItem({
  item,
  formatOptionLabel,
  disabled,
  isEditMode,
  dataTestId,
  onRemove,
}) {
  const handleClick = useCallbackRef((e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove(item.value);
  });

  return (
    <ListItem data-testid={dataTestId && `${dataTestId}-item-${encodeURIComponent(item.value)}`}>
      <span>{formatOptionLabel?.(item) ?? item.label}</span>

      {isEditMode && (
        <Button
          ghost
          disabled={disabled}
          data-testid={dataTestId && `${dataTestId}-remove-${encodeURIComponent(item.value)}`}
          onClick={handleClick}>
          <Icons.Remove />
        </Button>
      )}
    </ListItem>
  );
});
